import styled from 'styled-components';

export const EmptyStatesDoqContainer = styled.div`
  display: flex;
  height: 100%;
  align-items: center;
  width: 100%;
  justify-content: center;
`;
